let constants = () => {
    let env = "dev";
    switch (env) {
        case "dev":
            return {

                "BASE_URL": `${process.env.REACT_APP_BASE_COMMON}/`
            }
        default:
            return {}
    }
}

export default constants();